import {
  Typography,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'
import { formatPointerModifier } from 'src/shortcuts/pointerModifiers'

const shortcutsGeneral = [
  { keys: 'SHIFT + y', explanation: 'IFC anzeigen/ausblenden' },
  { keys: 'SHIFT + c', explanation: 'KI-Chat öffnen/schließen' },
  { keys: 'a', explanation: 'Vorschlag akzeptieren' },
  { keys: 'a', explanation: 'Auswahl / Import-Auswahl wechseln (IFC-Import)' },
  { keys: 't', explanation: 'Kommentar hinzufügen' },
]

const shortcuts3D = [
  { keys: '0, 1, ...', explanation: 'Stockwerke filtern' },
  { keys: '0, 1, ...  gedrückt halten', explanation: 'Nur ausgewähltes Stockwerk anzeigen' },
  { keys: 'SHIFT + r', explanation: 'Stockwerk DACH filtern' },
  { keys: 'd', explanation: 'Deckenpositionen filtern' },
  { keys: 'd gedrückt halten', explanation: 'Deckenelemente filtern' },
  { keys: 'r', explanation: 'Dachpositionen filtern' },
  { keys: 'r gedrückt halten', explanation: 'Dachelemente filtern' },
  { keys: 'p', explanation: 'Pfetten filtern' },
  { keys: 'o', explanation: '2D <-> 3D wechseln' },
  { keys: 'v', explanation: 'Auswahl ausblenden' },
  { keys: 'm', explanation: 'Maßband zeichnen/anzeigen wechseln' },
  { keys: 'm gedrückt halten', explanation: 'Maßband deaktivieren bzw. anzeigen' },
  { keys: 's', explanation: 'Schnittflächen sperren/Sperrung aufheben' },
  { keys: 'SHIFT + v', explanation: 'Alle Elemente einblenden' },
  { keys: 'CTRL + (0, 1, ..., "r")', explanation: 'zu aktivem Stockwerk in 2D wechseln' },
  {
    keys: `${formatPointerModifier('multiSelect').toUpperCase()} + Click`,
    explanation: 'Multi-Select für Bauteile',
  },
]

const shortcuts2D = [
  { keys: '0, 1, ...', explanation: 'Stockwerke filtern' },
  { keys: '0, 1, ... gedrückt halten', explanation: 'Nur ausgewähltes Stockwerk anzeigen' },
  { keys: '+, -', explanation: 'Grundriss hinein-/herauszoomen' },
  { keys: 'SHIFT + r', explanation: 'Stockwerk DACH filtern' },
  { keys: 'd', explanation: 'Deckenpositionen filtern' },
  { keys: 'd gedrückt halten', explanation: 'Deckenelemente filtern' },
  { keys: 'r', explanation: 'Dachpositionen filtern' },
  { keys: 'r gedrückt halten', explanation: 'Dachelemente filtern' },
  { keys: 'p', explanation: 'Pfetten filtern' },
  { keys: 'o', explanation: '2D <-> 3D wechseln' },
  { keys: 'v', explanation: 'Auswahl ausblenden' },
  { keys: 'm', explanation: 'Maßband zeichnen/anzeigen wechseln' },
  { keys: 'm gedrückt halten', explanation: 'Maßband deaktivieren bzw. anzeigen' },

  { keys: '←, →, ↑, ↓', explanation: 'Grundriss verschieben' },
  { keys: '#', explanation: 'Grundriss-Zoom und Position zurücksetzen' },
  { keys: 'f', explanation: 'Stockwerk Hintergrundplan anzeigen/ausblenden' },
  { keys: 'SHIFT + v', explanation: 'Alle Elemente einblenden' },
  { keys: 'CTRL + (0, 1, ..., "r")', explanation: 'aktives Stockwerk wechseln' },
]

export const ShortcutInfo = () => {
  return (
    <Stack direction="column" spacing={2}>
      <Stack direction="row" spacing={2}>
        <Stack direction="column" flexGrow={1} width="33%">
          <Typography align="center" variant="h6">
            General
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableBody>
                {shortcutsGeneral.map((shortcut, index) => (
                  <TableRow key={index}>
                    <TableCell>{shortcut.keys}</TableCell>
                    <TableCell>{shortcut.explanation}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        <Stack direction="column" flexGrow={1} width="33%">
          <Typography align="center" variant="h6">
            3D Mode
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableBody>
                {shortcuts3D.map((shortcut, index) => (
                  <TableRow key={index}>
                    <TableCell>{shortcut.keys}</TableCell>
                    <TableCell>{shortcut.explanation}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        <Stack direction="column" flexGrow={1} width="33%">
          <Typography align="center" variant="h6">
            2D Mode
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableBody>
                {shortcuts2D.map((shortcut, index) => (
                  <TableRow key={index}>
                    <TableCell>{shortcut.keys}</TableCell>
                    <TableCell>{shortcut.explanation}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Stack>
    </Stack>
  )
}
